import { Chip } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import {
    getProjectBridgeCanonicalStatusChipAriaLabel,
    getProjectBridgeCanonicalStatusChipLabel,
    getProjectBridgeCanonicalStatusChipVariant,
    hasProjectBridgeCanonicalUsagePopover,
} from "./project-bridge-rewrite-card-presenters"
import { ProjectBridgeCanonicalUsagePopover } from "./project-bridge-canonical-usage-popover"

export function ProjectBridgeCanonicalStatusChip({ item }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const label = getProjectBridgeCanonicalStatusChipLabel(item)
    const hasPopover = hasProjectBridgeCanonicalUsagePopover(item)
    const open = Boolean(anchorEl)
    const chipProps = buildChipProps()

    if (!label) return null

    return (
        <>
            <Chip
                size="small"
                label={label}
                color="info"
                variant={getProjectBridgeCanonicalStatusChipVariant(item)}
                data-cy="project-bridge-canonical-status-chip"
                {...chipProps}
            />
            <ProjectBridgeCanonicalUsagePopover anchorEl={anchorEl} open={open} item={item} onClose={handleClose} />
        </>
    )

    function handleOpen(event) {
        if (!hasPopover) return
        setAnchorEl(event.currentTarget)
    }

    function handleClose() {
        setAnchorEl(null)
    }

    function buildChipProps() {
        if (!hasPopover) return {}

        return {
            icon: <Iconify icon="mdi:link-variant" />,
            clickable: true,
            onClick: handleOpen,
            "aria-label": getProjectBridgeCanonicalStatusChipAriaLabel(item),
            "aria-haspopup": "dialog",
            "aria-expanded": open,
            sx: {
                cursor: "pointer",
                fontWeight: 600,
                "& .MuiChip-icon": {
                    color: "inherit",
                },
                "&:hover": {
                    boxShadow: 1,
                },
            },
        }
    }
}
